/**
 * This module overrides console.error to look for specific LiveView errors indicating the LiveView is dead.
 */

import posthog from 'posthog-js'

const originalErrorHandler = window.console.error

export function customErrorHandler(...args: any[]) {
  originalErrorHandler(...args)

  if (logIndicatesLiveViewIsDead(...args)) {
    originalErrorHandler('LiveView connection appears to have failed')
    posthog.captureException(new Error('LiveView is dead'))
  }
}

function logIndicatesLiveViewIsDead(...args: any[]) {
  return args.some((arg) => typeof arg === 'string' && arg.includes('no component found matching phx-target'))
}
